module.exports = __webpack_public_path__ + "img/982d05b.jpg";